import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Document from '../../document';
import { getDocuments, createDocuments, deleteDocument } from '../../../reducers/documents';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { HelpButton } from '../../richButtons';
import { PERMISSIONS } from '../../document/types';
import { icDocuments, icDocumentsList } from '../../../utilities/regime';

class IcContinueRequestDocs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            documentsStatus: {},
            uploadedDocuments: []
        };

        this.handleDoc = this.handleDoc.bind(this);
        this.renderUploadButton = this.renderUploadButton.bind(this);
        this.renderDocumentRow = this.renderDocumentRow.bind(this);
        this.getDocumentModel = this.getDocumentModel.bind(this);
        this.onUploaded = this.onUploaded.bind(this);
        this.onRemove = this.onRemove.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { documents, IC_DOCUMENTS } = nextProps;

        if (!documents) {
            return;
        }

        const documentsStatus = {};
        Object.entries(IC_DOCUMENTS).forEach(([_, doc]) => {
            const existingDoc = documents.find(d => d.doc_type === doc.type);
            if (existingDoc) {
                documentsStatus[doc.type] = existingDoc.status;
            }
        });

        this.setState({
            documentsStatus: { ...this.state.documentsStatus, ...documentsStatus },
            uploadedDocuments: documents.filter(d => d.status === 'active')
        });
    }

    componentDidMount() {
        const { getDocuments, role } = this.props;
        getDocuments({ ...role, includeAll: true });
    }

    getDocumentModel(doc, status) {
        const { role } = this.props;

        return {
            doc_type: doc.type,
            display_name: doc.label,
            name: `${doc.id}_${role.id}`,
            ref_id: role.id,
            ref_type: role.type,
            permissions: PERMISSIONS.CLIENT_UPLOAD,
            status
        };
    }

    handleDoc(status, documentType, click = () => null) {
        const { documents, createDocuments, IC_DOCUMENTS } = this.props;
        const { documentsStatus } = this.state;

        documentsStatus[documentType] = status;
        this.setState({ documentsStatus }, click);

        if (['never', 'later'].includes(status)) {
            const existingDoc = documents.find(d => d.doc_type === documentType);
            const doc = this.getDocumentModel(IC_DOCUMENTS[documentType], status);
            if (existingDoc) {
                doc.id = existingDoc.id;
            }
            createDocuments([doc]);
        }
    }

    renderUploadButton(click, type) {
        const { documents, readOnly, IC_DOCUMENTS } = this.props;

        if (!documents) {
            return;
        }

        const { documentsStatus } = this.state;
        const status = documentsStatus[type];

        if (status === 'active' && documents.filter(d => d.doc_type === type).length >= IC_DOCUMENTS[type].limit) {
            return;
        }

        return status && status !== 'active' ? (
            <div className="document-actions">
                <div className="selected">
                    {status === 'later' ? <FormattedMessage {...messages.willSubmitLater} /> : <FormattedMessage {...messages.dontHaveDocument} />}
                </div>
                {!readOnly && (
                    <div onClick={() => this.handleDoc(undefined, type)} className="action">
                        <FormattedMessage {...messages.change} />
                    </div>
                )}
            </div>
        ) : status ? (
            !readOnly && (
                <div className="document-actions">
                    <div onClick={() => this.handleDoc('active', type, click)} className="button optionalButton">
                        <FormattedMessage {...messages.uploadMore} />
                    </div>
                </div>
            )
        ) : (
            <div className="document-actions">
                <div onClick={() => this.handleDoc(null, type, click)} className="button">
                    <FormattedMessage {...messages.upload} />
                </div>
                <div onClick={() => this.handleDoc('later', type)} className="action">
                    <FormattedMessage {...messages.submitLater} />
                </div>
                <div onClick={() => this.handleDoc('never', type)} className="action">
                    <FormattedMessage {...messages.dontHave} />
                </div>
            </div>
        );
    }

    onUploaded(doc) {
        const { documents, role, getDocuments, deleteDocument } = this.props;
        const existingDoc = documents.find(d => d.doc_type === doc.doc_type && ['never', 'later'].includes(d.status));
        if (existingDoc) {
            this.setState({ documentsStatus: { ...this.state.documentsStatus, [doc.doc_type]: 'active' } });
            deleteDocument(existingDoc.id, () => getDocuments({ ...role, includeAll: true }));
        }
    }

    onRemove(doc) {
        const { role, getDocuments, createDocuments, documents, IC_DOCUMENTS } = this.props;

        const existingDocs = documents.filter(d => d.doc_type === doc.doc_type && d.id !== doc.id);

        if (!existingDocs.length) {
            this.setState({ documentsStatus: { ...this.state.documentsStatus, [doc.doc_type]: 'later' } });
            createDocuments([this.getDocumentModel(IC_DOCUMENTS[doc.doc_type], 'later')], () => getDocuments({ ...role, includeAll: true }));
        } else {
            getDocuments({ ...role, includeAll: true });
        }
    }

    renderDocumentRow(docInfo) {
        const { documents, readOnly, role } = this.props;
        const { uploadedDocuments } = this.state;

        if (!documents) {
            return;
        }
        const { id, type, label, helpText, limit } = docInfo;
        const multipleClass = limit > 1 ? ' documentMarketing' : '';

        return (
            <div className="document-wrapper">
                <div className="documentRow">
                    <div className="documentTitle">
                        <FormattedMessage id={`${id}-label`} defaultMessage={label} tagName={'h5'} />
                        <HelpButton text={<FormattedMessage id={`${id}-help`} defaultMessage={helpText} />} />
                    </div>
                    <div className="documentList">
                        <div className={multipleClass}>
                            <Document
                                id={id}
                                docType={type}
                                view={{ component: 'upload-later', removeCalback: this.onRemove, readOnly }}
                                upload={{ limit, permissions: PERMISSIONS.CLIENT_UPLOAD, button: this.renderUploadButton, onUploaded: this.onUploaded }}
                                providedDocuments={uploadedDocuments}
                                ownerRole={role}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { documents, regime } = this.props;

        if (!documents) {
            return null;
        }

        return (
            <div className="row">
                <div className="col-xs-12">{icDocuments(regime, this.renderDocumentRow)}</div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const role = props.role || state.identity.role;
    const prop = `${role.id}-all`;
    const documents = state.documents[prop];
    return {
        role,
        documents: documents ? documents.list : undefined,
        signatures: state.signatures.list,
        regime: props.regime || (state.jobs.list || [{}])[0].regime,
        IC_DOCUMENTS: icDocumentsList(props.regime)
    };
};
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getDocuments,
            createDocuments,
            deleteDocument
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(IcContinueRequestDocs);



// WEBPACK FOOTER //
// ./src/components/lists/workerDocumentsICContinue/index.jsx